"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fadeOutScaleClass = exports.fadeOutScaleAnimation = void 0;
const nano_theme_1 = require("nano-theme");
exports.fadeOutScaleAnimation = (0, nano_theme_1.keyframes)({
    to: {
        op: 0,
        tr: 'scale(.95)',
    },
});
exports.fadeOutScaleClass = (0, nano_theme_1.rule)({
    an: exports.fadeOutScaleAnimation + ' .25s ease-out',
    animationFillMode: 'forwards',
});
